
const development ={  //development
    appid : 'wxa5e11ad0c054e360',
    secret : '908cb93d4bc4a8849245f2de548075c2',
    serverHost : 'http://hh.stage.hadeling.com',
    loginMode : '/NoInweixin'
};
const hadeling ={  //production  REACT_APP_SECRET_CODE
    appid : 'wxa5e11ad0c054e360',
    secret : '908cb93d4bc4a8849245f2de548075c2',
    serverHost : 'http://hh.prod.hadeling.com',
    loginMode : '/NoInweixin'
};
let Config;
  if(window.location.host==='xlcrk.hadeling.com'){
    Config = hadeling;
 }else if(window.location.host==='stage.hadeling.com'){
    Config = development;
 }else{
    Config = development;
 }

export default Config;
export const oauth2 ={
    access_token : 'https://api.weixin.qq.com/sns/oauth2/access_token'
};
export const MethodType = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH:'PATCH'
  };